import { type InfiniteData, type QueryClient } from 'react-query'

import { type IInfinitePage } from 'types/interfaces/ITypes'

const updatePostPollAnswer = async (
    postId: string,
    dataQuery: any,
    queryClient: QueryClient,
    answer: string | string
) => {
    const cachedData =
        queryClient.getQueryData<InfiniteData<IInfinitePage>>(dataQuery)

    if (cachedData) {
        const newData = {
            ...cachedData,
            pages: cachedData.pages.map(singleFeedPage => {
                return {
                    ...singleFeedPage,
                    page: {
                        ...singleFeedPage.page,
                        data: {
                            ...singleFeedPage.page.data,
                            data: singleFeedPage.page.data.data.map(post => {
                                return post.poll != null && post.id === postId
                                    ? {
                                          ...post,
                                          poll: {
                                              ...post.poll,
                                              is_answered: answer,
                                              answer,
                                              answers_count: [
                                                  ...post.poll.answers_count.map(
                                                      item => {
                                                          if (
                                                              String(item.id) ===
                                                              String(answer)
                                                          )
                                                              return {
                                                                  ...item,
                                                                  count:
                                                                      item.count +
                                                                      1
                                                              }
                                                          else
                                                              return item
                                                      }
                                                  )
                                              ]
                                          }
                                      }
                                    : post
                            })
                        }
                    }
                }
            })
        }

        queryClient.setQueryData(dataQuery, newData)
    }

    return { cachedData }
}

export { updatePostPollAnswer }